import { CategoryIconOption } from './AdminDashboard.types';

export const CATEGORY_ICONS: CategoryIconOption[] = [
  { value: 'home', label: '🏠 Home', iconName: 'home-outline' },
  { value: 'room', label: '🏠 Room', iconName: 'bed-outline' },
  { value: 'water', label: '💧 Water', iconName: 'water-outline' },
  { value: 'electrical', label: '⚡ Electrical', iconName: 'flash-outline' },
  { value: 'heating', label: '🔥 Heating', iconName: 'fire' },
  { value: 'cooling', label: '❄️ Cooling', iconName: 'snowflake' },
  { value: 'safety', label: '🛡️ Safety', iconName: 'shield-check-outline' },
  { value: 'tools', label: '🔧 Tools', iconName: 'wrench-outline' },
  { value: 'folder', label: '📁 Folder', iconName: 'folder-outline' },
  { value: 'check', label: '✅ Check', iconName: 'check-circle-outline' },
];
